var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list-dropdown" }, [
    _c("input", {
      staticClass: "list-dropdown__trigger",
      attrs: { type: "checkbox", id: "heroLd1" },
      domProps: { checked: _vm.isOpen },
      on: { click: _vm.toggle }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "list-dropdown__wrapper" }, [
      _c(
        "label",
        { staticClass: "list-dropdown__title", attrs: { for: "heroLd1" } },
        [
          _c("span", { staticClass: "title" }, [_vm._v("Район")]),
          _vm._v(" "),
          _vm.selectedDistricts && _vm.selectedDistricts.length > 0
            ? _c("span", { staticClass: "count" }, [
                _vm._v(_vm._s(_vm.selectedDistricts.length))
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c("div", { staticClass: "list-dropdown__container" }, [
            _c("div", { staticClass: "list-dropdown__content" }, [
              _c("div", { staticClass: "list-dropdown__search" }, [
                _c("label", { staticClass: "input-container" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchDistrict,
                        expression: "searchDistrict"
                      }
                    ],
                    attrs: { type: "text", placeholder: "Поиск" },
                    domProps: { value: _vm.searchDistrict },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchDistrict = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list-dropdown__scroll" },
                [
                  _vm.districtsFiltered.length == 0
                    ? _c("div", { attrs: { role: "alert" } }, [
                        _vm._v("Нет результатов")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.districtsFiltered, function(dist) {
                    return _c(
                      "label",
                      { key: dist, staticClass: "input-container" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedDistricts,
                              expression: "selectedDistricts"
                            }
                          ],
                          attrs: { type: "checkbox", name: "district" },
                          domProps: {
                            value: dist,
                            checked: Array.isArray(_vm.selectedDistricts)
                              ? _vm._i(_vm.selectedDistricts, dist) > -1
                              : _vm.selectedDistricts
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.selectedDistricts,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = dist,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedDistricts = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedDistricts = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedDistricts = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "input-container__label" }, [
                          _vm._v(_vm._s(dist))
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "list-dropdown__bg" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }